// extracted by mini-css-extract-plugin
export var v2Location = "Location-module--v2Location--WeA84";